import * as React from 'react'
const CheckmarkUnchecked = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <rect width={21} height={21} x={1.5} y={1.5} stroke="#D9D9D9" strokeWidth={3} rx={10.5} />
  </svg>
)
export default CheckmarkUnchecked
